/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_GuaranteeInputs */

const et_nav_guarantee = /** @type {(inputs: Nav_GuaranteeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garantii`)
};

const en_nav_guarantee = /** @type {(inputs: Nav_GuaranteeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guarantee`)
};

/**
* | output |
* | --- |
* | "Guarantee" |
*
* @param {Nav_GuaranteeInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_guarantee = /** @type {((inputs?: Nav_GuaranteeInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_GuaranteeInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_nav_guarantee(inputs)
	return en_nav_guarantee(inputs)
});